<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="2" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        title:'何謂放射手術?',
        videosrc:'R02.mp4',
        list:[
          {
            title:'',
            body:"隨著醫療科技的進步，多數手術治療逐漸朝向低侵入性、甚至是非侵入性的方向演進，其中立體定位放射手術(SRS)就是一種非侵入性的治療，在某些病況下其效果接近手術廓清效果；因此在高風險的顱內治療領域，其應用性逐年上升。"
          }

        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
